<div  *ngIf="pays">
    <div class="chart-wrapper">
        <canvas baseChart 
        [data]="doughnutChartData"
        [labels]="doughnutChartLabels"
        [chartType]="doughnutChartType" 
        [legend]="true"
        (click)="chartClicked($event.label)"
        height="auto"
        [legend]="true"
        [options]="options"
        width="140">
      </canvas>
    </div>
</div>
